module.exports = __webpack_public_path__ + "media/images/blog-image-1-6733ce0de6de5247633457fddc34438b.jpg";